<form class="flex flex-col gap-2" [formGroup]="form" (ngSubmit)="submit()">
  @if (form.dirty && form.errors) {
    <div class="form-errors">
      @for (error of form.errors | keyvalue; track error.key) {
        <pt-alert [alert]="error.value" />
      }
    </div>
  }

  <mat-form-field class="w-full">
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" required />
  </mat-form-field>

  <div class="flex items-center gap-2">
    <mat-form-field class="w-full">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" />
    </mat-form-field>

    <mat-form-field
      class="w-full"
      hintLabel="Min {{ minPhoneLength }} characters"
    >
      <mat-label>Phone</mat-label>
      <input matInput formControlName="phone" />
      <mat-hint align="end">
        {{ form.value?.phone?.length || 0 }}/{{ minPhoneLength }}
      </mat-hint>
    </mat-form-field>
  </div>

  <div class="flex items-center gap-2">
    <mat-form-field class="w-full">
      <mat-label>Job Title</mat-label>
      <input matInput formControlName="jobTitle" />
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Mobile Number</mat-label>
      <input matInput formControlName="mobileNumber" />
    </mat-form-field>
  </div>

  <pr-address-input formControlName="address" />

  <pr-tags-input
    class="w-full"
    formControlName="tags"
    [tagCol]="tagCol()"
    [tagType]="tagType"
  />

  <button type="submit" hidden></button>
</form>
